var map = {
	"./fangxin.png": "0ca0",
	"./funeng.png": "c25f",
	"./gaoshouyi.png": "d403",
	"./hefa.png": "0d6b",
	"./niuping.png": "38a0",
	"./siyu.png": "430f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2244";